<div class="bg-pale bolt-container-fluid no-pad pt-20">
  <div class="bolt-row bolt-align-items-center bolt-justify-content-between">
    <div class="bolt-col-xs-12 bolt-col-sm-6">
      <h2 class="tab-header">Programs applied to this auto quote</h2>
    </div>
    @if (shouldProposeReenrollExcluded) {
      <div
        class="bolt-col-xs-12 bolt-col-md-3 change-btn"
        >
        <!-- When explicitly disabled (ie no telematics present at retrieve) -->
        <bolt-button
          type="solid"
          class="float-right text-nowrap"
          [attr.id]="'tc-enroll-lowest-cost-program-btn'"
          [size]="maxSizeMedium ? 'sm' : 'md'"
          (click)="reenrollExcluded()"
          width="full-md"
          >Enroll lowest cost programs</bolt-button
          >
        </div>
      }
      @if (!!enrollment && !isRecommendationEnrolled) {
        <div
          class="bolt-col-xs-12 bolt-col-md-3 change-btn"
          >
          <!-- Enrolled in something that is not the recommendation -->
          <bolt-button
            type="solid"
            class="float-right text-nowrap"
            [attr.id]="'tc-enroll-lowest-cost-program-btn'"
            (click)="resetAllPrograms()"
            [attr.size]="maxSizeMedium ? 'sm' : 'md'"
            width="full-md"
            >Enroll lowest cost programs</bolt-button
            >
          </div>
        }
        @if (isAnyTelematicsEnrolled) {
          <div
            class="bolt-col-xs-12 bolt-col-md-2 change-btn"
            >
            <bolt-button
              class="float-right text-nowrap"
              [attr.id]="'tc-remove-all-program-btn'"
              (click)="removeAllPrograms()"
              [attr.size]="maxSizeMedium ? 'sm' : 'md'"
              width="full-md"
              >Remove all programs</bolt-button
              >
            </div>
          }
        </div>
        <p class="description">
          The auto quote reflects savings associated with these optional programs.
        </p>
        @if (isRecommendationEnrolled) {
          <div>
            <p class="description">
              <em
                >Each vehicle is enrolled in the program that could provide the highest
                potential savings.</em
                >
              </p>
            </div>
          }

          @if (displaySmartRideDataSharingConsent()) {
            <div
              class="card sri-consent-card"
              >
              <div class="bolt-row bolt-align-items-center">
                <div class="bolt-col-1">
                  <bolt-icon name="info-circle-filled" color="theme-info"></bolt-icon>
                </div>
                <div class="bolt-col-8">
                  <p>
                    <strong
                      >Consent is required to determine qualification for SmartRide
                      Instant</strong
                      >
                    </p>
                    <p>
                      To apply discounts, when available, Nationwide Insurance partners with
                      vehicle manufacturers and third parties to collect vehicle driving
                      data.
                    </p>
                  </div>
                  <div class="bolt-col-3">
                    <bolt-button (click)="openSmartRideDataSharingModal()"
                      >Grant consent <bolt-icon name="pencil" size="sm"></bolt-icon
                    ></bolt-button>
                  </div>
                </div>
              </div>
            }

            @if (smartRideInstantVehicles.length) {
              <div
                id="smartride-instant"
                class="card"
                >
                <h3 class="card-header">
                  <img
                    class="tm-icon"
                    src="assets/images/telematics/connected-car.svg"
                    alt=""
                    />
                    @if (!isCA) {
                      SmartRide&reg; safe-driving discount
                    } @else {
                      SmartRide&reg; low-mileage discount
                    }
                  </h3>
                  <div class="card-body">
                    <nwx-smartride-instant-enrollment
                      [vehicles]="smartRideInstantVehicles"
                      [quoteState]="quoteState"
                      [enrollment]="enrollment"
                    ></nwx-smartride-instant-enrollment>
                    @if (premium?.total?.amount) {
                      <div
                        class="bolt-container-fluid bolt-body-copy-sm"
                        id="premiumDisclaimer-SRInstant"
                        >
                        <sup>*</sup>cost included in the total premium of
                        {{ premium?.total?.amount | currency }}
                      </div>
                    }
                  </div>
                </div>
              }
              @if (smartRideConnectedCarVehicles.length) {
                <div
                  id="smartride-connected-car"
                  class="card"
                  >
                  <h3 class="card-header">
                    <img
                      class="tm-icon"
                      src="assets/images/telematics/connected-car.svg"
                      alt=""
                      />
                      @if (!isCA) {
                        SmartRide&reg; safe-driving discount
                      } @else {
                        SmartRide&reg; low-mileage discount
                      }
                    </h3>
                    <div class="card-body">
                      <nwx-smartride-connected-car-enrollment
                        [vehicles]="smartRideConnectedCarVehicles"
                        [quoteState]="quoteState"
                        [quoteEffectiveDate]="quoteEffectiveDate"
                        [enrollment]="enrollment"
                      ></nwx-smartride-connected-car-enrollment>
                      @if (premium?.total?.amount) {
                        <div
                          class="bolt-container-fluid bolt-body-copy-sm"
                          id="premiumDisclaimer-SRConnectedCar"
                          >
                          <sup>*</sup>cost included in the total premium of
                          {{ premium?.total?.amount | currency }}
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (smartMilesConnectedCarVehicles.length) {
                  <div
                    id="smartmiles-connected-car"
                    class="card"
                    >
                    <h3 class="card-header">
                      <img
                        class="tm-icon"
                        src="assets/images/telematics/connected-car.svg"
                        alt=""
                        />
                        SmartMiles&reg; pay-per-mile program
                      </h3>
                      <div class="card-body">
                        <nwx-smartmiles-connected-car-enrollment
                          [vehicles]="smartMilesConnectedCarVehicles"
                          [quoteState]="quoteState"
                          [enrollment]="enrollment"
                          [maxSizeMini]="maxSizeMini"
                        ></nwx-smartmiles-connected-car-enrollment>
                        @if (premium?.total?.amount) {
                          <div
                            class="bolt-container-fluid bolt-body-copy-sm"
                            id="premiumDisclaimer-SMConnectedCar"
                            >
                            <sup>*</sup>cost included in the total premium of
                            {{ premium?.total?.amount | currency }}
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (smartMilesVehicles.length) {
                    <div id="smartmiles" class="card">
                      <h3 class="card-header">
                        <img
                          class="tm-icon"
                          src="assets/images/telematics/smartride-white.svg"
                          alt=""
                          />
                          SmartMiles&reg; pay-per-mile program
                        </h3>
                        <div class="card-body">
                          <nwx-smartmiles-enrollment
                            [vehicles]="smartMilesVehicles"
                            [quoteState]="quoteState"
                            [enrollment]="enrollment"
                            [maxSizeMini]="maxSizeMini"
                          ></nwx-smartmiles-enrollment>
                          @if (premium?.total?.amount) {
                            <div
                              class="bolt-container-fluid bolt-body-copy-sm"
                              id="premiumDisclaimer-SmartMiles"
                              >
                              <sup>*</sup>cost included in the total premium of
                              {{ premium?.total?.amount | currency }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (smartRideVehicles.length) {
                      <div id="smartride" class="card">
                        <h3 class="card-header">
                          <img
                            class="tm-icon"
                            src="assets/images/telematics/smartride-white.svg"
                            alt=""
                            />
                            @if (!isCA) {
                              SmartRide&reg; safe-driving discount
                            } @else {
                              SmartRide&reg; low-mileage discount
                            }
                          </h3>
                          <div class="card-body">
                            <nwx-smartride-enrollment
                              [vehicles]="smartRideVehicles"
                              [isMobile]="isMobile"
                              [quoteState]="quoteState"
                              [quoteEffectiveDate]="quoteEffectiveDate"
                              [enrollment]="enrollment"
                              [maxSizeMini]="maxSizeMini"
                            ></nwx-smartride-enrollment>
                            @if (premium?.total?.amount) {
                              <div
                                class="bolt-container-fluid bolt-body-copy-sm"
                                id="premiumDisclaimer-SmartRide"
                                >
                                <sup>*</sup>cost included in the total premium of
                                {{ premium?.total?.amount | currency }}
                              </div>
                            }
                          </div>
                        </div>
                      }
                      @if (unenrolledVehicles.length) {
                        <div id="unenrolled" class="card">
                          <h3 class="card-header">No usage-based insurance program</h3>
                          <div class="card-body">
                            <nwx-no-program-enrollment
                              [vehicles]="unenrolledVehicles"
                              [enrollment]="enrollment"
                            ></nwx-no-program-enrollment>
                          </div>
                        </div>
                      }
                    </div>
